import {Localisation, Modifier} from "../components/localisation/localisation";

export class Member {
    static ParseToken(token: string) {
        const [pathString, modifiersString] = token.split(":");
        const path = pathString.split(".");
        const modifiers = modifiersString?.split(";") ?? [];

        return new Member(path, modifiers);
    }

    constructor(private path: string[], private modifiers: string[]) {
    }

    getMember(parameters: any) {
        const path = [...this.path];
        let member = parameters;

        while (path.length) {
            const child = path.shift()!;

            if (member[child] !== undefined) {
                member = member[child];
            } else {
                break;
            }
        }
        return member;
    }

    getMemberText(parameters: any) {
        const member = this.getMember(parameters);

        if (typeof(member) === "string" || typeof(member) === "number") {
            return member.toString();
        } else if (Array.isArray(member)) {
            return member.map(member => member.toString()).join(", ");
        } else {
            return this.path.join(".");
        }
    }

    getText(parameters: any, modifiers: Record<string, Modifier>) {
        let text = this.getMemberText(parameters);

        text = Localisation.GetRawText(text);
        this.modifiers.forEach(modifier => {
            text = modifiers[modifier](text, parameters)
        })
        return text;
    }
}